// Icones da Politica Comercial (spec 27/09), no mesmo estilo de IconesDaFicha
// -- SVG inline de linha, sem biblioteca nova.
type P = { tamanho?: number }
const base = (t: number) => ({
  viewBox: '0 0 24 24', width: t, height: t, fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.8, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true,
})
export function IconeCalendario({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4M7 14h2M11 14h2M15 14h2M7 17h2M11 17h2" /></svg>
}
export function IconeCartao({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20M6 15h4" /></svg>
}
export function IconeCaminhao({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7" /><circle cx="7" cy="17.5" r="1.5" /><circle cx="17" cy="17.5" r="1.5" /></svg>
}
export function IconeEscudo({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="M12 3 4 6v6c0 4.4 3.4 8.2 8 9 4.6-.8 8-4.6 8-9V6Z" /><path d="m9 12 2 2 4-4" /></svg>
}
export function IconePix({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="m12 3 4 4-4 4-4-4ZM12 13l4 4-4 4-4-4ZM3 12l4-4 4 4-4 4ZM13 12l4-4 4 4-4 4Z" /></svg>
}
export function IconeCodigoBarras({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="M4 5v14M7 5v14M10 5v14M14 5v14M17 5v14M20 5v14" /></svg>
}
export function IconeNota({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><rect x="2" y="6" width="20" height="12" rx="2" /><circle cx="12" cy="12" r="2.5" /><path d="M6 12h.01M18 12h.01" /></svg>
}
export function IconeSetas({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="M4 9h13l-3-3M20 15H7l3 3" /></svg>
}
export function IconeMaoMoeda({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><circle cx="15" cy="7" r="3" /><path d="M2 15h4l3-1h4a1.5 1.5 0 0 1 0 3h-3M6 20h7l6-4a1.5 1.5 0 0 0-2-2l-3 1.5" /></svg>
}
export function IconeMais({ tamanho = 16 }: P) {
  return <svg {...base(tamanho)}><path d="M12 5v14M5 12h14" /></svg>
}
export function IconeTresPontos({ tamanho = 18 }: P) {
  return <svg {...base(tamanho)}><path d="M5 12h.01M12 12h.01M19 12h.01" strokeWidth={3} /></svg>
}
export function IconeSeta({ tamanho = 16 }: P) {
  return <svg {...base(tamanho)}><path d="m6 9 6 6 6-6" /></svg>
}
